import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import { useAppContextOrThrow } from 'utils';

const Footer = styled.footer`
    background-color: #d6d6d6
    font-family: ${theme.fonts.light};
    font-size: 16px;
    padding: 20px 0;
    position: relative;
    z-index: 10;

    @media (max-width: 768px) {
        padding: 20px 0 80px;
    }
`;

const Column = styled.div`
    padding: 30px;
    margin: 0 10px;
    max-width: 300px;
    @media (max-width: 660px) {
        padding: 10px;
    }
`;

const Title = styled.h3`
    font-family: ${theme.fonts.light};
    font-size: 25px;
`;

const Social = styled.a`
    margin: 0 5px 10px 0;
    display: inline-block;
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: auto;
    max-width: 1230px;
`;

const Bold = styled.span`
    font-family: ${theme.fonts.regular};
`;

export const LinkInsideFooter = styled.a`
    color: ${theme.colors.main};
    cursor: pointer;
    font-family: ${theme.fonts.medium};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        color: ${theme.colors.main};
    }
`;

const FooterLink = styled(LinkInsideFooter)`
    display: block;
    font-family: ${theme.fonts.light};
    color: #803675;
    &:hover {
        text-decoration: underline;
    }
`;

const links = [
    {
        title: 'Alma Talent Tietopalvelut',
        path:
            'https://www.almatalent.fi/tietopalvelut/asiakaspalvelu/tietoa-meista'
    },
    {
        title: 'Tilaa lisää palveluja',
        path: 'https://tietopalvelut.almatalent.fi/tilaa-lisaa-palveluita/',
        forTPUsers: true
    },
    {
        title: 'Tilaa lisää tunnuksia',
        path:
            'https://tietopalvelut.almatalent.fi/tilaa-lisaa-kayttajatunnuksia/',
        forTPUsers: true
    },
    {
        title: 'Yhteystiedot',
        path:
            'https://www.almatalent.fi/tietopalvelut/asiakaspalvelu/yhteystiedot'
    },
    {
        title: 'Hinnasto',
        path: 'https://tietopalvelut.almatalent.fi/hinnasto/',
        forTPUsers: true
    },
    {
        title: 'Sopimusehdot',
        path: 'https://tietopalvelut.almatalent.fi/sopimusehdot/'
    },
    {
        title: 'Tilaus- ja käyttäjärekisteriseloste',
        path:
            'https://tietopalvelut.almatalent.fi/rekisteriselosteet/tilaus-ja-kayttajarekisteriseloste/'
    },
    {
        title: 'Tiedontuottajat',
        path: 'https://www.almatalent.fi/tietopalvelut/tiedontuottajat'
    }
];

function CommonFooter() {
    const context = useAppContextOrThrow();

    const isLoggedIn = context.state.auth.authenticated;
    const renderedLinks = links.map(link =>
        !isLoggedIn ? (
            !link.forTPUsers && (
                <FooterLink key={link.title} href={link.path}>
                    {link.title}
                </FooterLink>
            )
        ) : (
            <FooterLink key={link.title} href={link.path}>
                {link.title}
            </FooterLink>
        )
    );

    return (
        <Footer className="no-print">
            <Wrapper>
                <Column>
                    <Title>
                        Alma Talent Oy, <br />
                        Tietopalvelut
                    </Title>
                    <Social
                        href="https://www.facebook.com/Almatalent/"
                        target="_blank"
                        rel="noopener"
                    >
                        <img
                            src="https://static.almamedia.fi/images/default-source/default-album/facebook-icon-grey.png?sfvrsn=ce6b12ed_0"
                            alt="facebook-icon"
                        />
                    </Social>
                    <Social
                        href="https://twitter.com/Alma_Talent"
                        target="_blank"
                        rel="noopener"
                    >
                        <img
                            src="https://static.almamedia.fi/images/default-source/default-album/twitter-icon-grey.png?sfvrsn=ff6812ed_0"
                            alt="twitter-icon"
                        />
                    </Social>
                    <Social
                        href="https://www.linkedin.com/company/alma-talent/"
                        target="_blank"
                        rel="noopener"
                    >
                        <img
                            src="https://static.almamedia.fi/images/default-source/default-album/linkedin-icon-grey.png?sfvrsn=e46812ed_0"
                            alt="linkedin-icon"
                        />
                    </Social>
                    <p>
                        <Bold>Vaihde:</Bold> <br />
                        <FooterLink href="tel:+010665101">
                            010 665 101
                        </FooterLink>
                    </p>
                    <p>
                        <Bold>Postiosoite:</Bold> <br />
                        PL 73, 00101 Helsinki
                    </p>
                    <p>
                        <Bold>Käyntiosoite:</Bold>
                        <br /> Alvar Aallon katu 3 C, <br />
                        00100 Helsinki
                    </p>
                </Column>
                <Column>
                    <Title>Asiakaspalvelu</Title>
                    <p>
                        <Bold>Puhelin:</Bold>
                        <br />{' '}
                        <FooterLink href="tel:+0800141070">
                            0800 141 070
                        </FooterLink>
                        (ma-pe klo 8.30-16.30)
                    </p>
                    <p>
                        <Bold>Sähköposti:</Bold>
                        <br />
                        <FooterLink href="mailto:tietopalvelut@almatalent.fi">
                            tietopalvelut@almatalent.fi
                        </FooterLink>
                    </p>
                    <p>
                        <FooterLink href="https://www.almatalent.fi/tietopalvelut/lomakkeet/ota-yhteytta">
                            Yhteydenottolomake
                        </FooterLink>
                    </p>
                </Column>
                <Column>{renderedLinks}</Column>
            </Wrapper>
        </Footer>
    );
}
export default CommonFooter;
